/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const validMap = ['admin', 'editor'];
  return validMap.indexOf(str.trim()) >= 0;
}


// 手机号验证
/* eslint-disable-next-line */
export const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请填写手机号"));
  }
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入正确的手机号"));
  }
};

// 密码验证
/* eslint-disable-next-line */
export const checkPass = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入密码"));
  }
  // 8-20位的数字或者字母
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("密码为8-16位数字加字母组合"));
  }
};
// 名称验证，不能输入特殊符号
/* eslint-disable-next-line */
export const checkName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入名称"));
  }
  // 8-20位的数字或者字母
  const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("不能包含特殊符号"));
  }
};
